/* Premium Skincare Product Page — behavior
   No build step required. Vanilla JS, scoped per section instance. */
(function () {
  'use strict';

  function init(section) {
    var sectionId = section.dataset.sectionId;
    var root = document;

    /* ---------- Star rating fill ---------- */
    root.querySelectorAll('[data-psp-rating]').forEach(function (el) {
      var rating = parseFloat(el.dataset.rating || '0');
      var fill = Math.max(0, Math.min(100, (rating / 5) * 100));
      el.style.setProperty('--fill', fill);
    });

    /* ---------- Gallery: thumbnails, hover-swap, zoom, swipe ---------- */
    var gallery = section.querySelector('[data-psp-gallery]');
    if (gallery) {
      var mainImg = gallery.querySelector('[data-psp-main-image]');
      var zoomBox = gallery.querySelector('[data-psp-zoom]');
      var thumbs = gallery.querySelectorAll('[data-psp-thumb]');
      var dots = gallery.querySelectorAll('[data-psp-dots] .psp-dot');
      var primarySrc = mainImg ? mainImg.getAttribute('src') : null;
      var secondarySrc = mainImg ? mainImg.dataset.secondary : null;
      var activeIndex = 0;

      function setActiveThumb(index) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        activeIndex = index;
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.style.opacity = 0;
          setTimeout(function () {
            mainImg.src = thumb.dataset.full;
            mainImg.alt = thumb.dataset.alt || '';
            primarySrc = thumb.dataset.full;
            mainImg.style.opacity = 1;
          }, 120);
          setActiveThumb(i);
        });
      });

      /* hover swap to secondary image on the main stage */
      if (mainImg && secondarySrc) {
        zoomBox.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            mainImg.src = secondarySrc;
          }
        });
        zoomBox.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            mainImg.src = primarySrc;
          }
        });
      }

      /* click-to-zoom (toggle scaled state, follow cursor) */
      if (zoomBox && mainImg) {
        zoomBox.addEventListener('click', function () {
          zoomBox.classList.toggle('is-zoomed');
        });
        zoomBox.addEventListener('mousemove', function (e) {
          if (!zoomBox.classList.contains('is-zoomed')) return;
          var rect = zoomBox.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          mainImg.style.transformOrigin = x + '% ' + y + '%';
        });
        zoomBox.addEventListener('mouseleave', function () {
          zoomBox.classList.remove('is-zoomed');
        });
      }

      /* swipe gestures (mobile) cycle through thumbnails/images */
      if (zoomBox && thumbs.length > 1) {
        var touchStartX = 0;
        zoomBox.addEventListener('touchstart', function (e) {
          touchStartX = e.changedTouches[0].clientX;
        }, { passive: true });
        zoomBox.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) < 40) return;
          var next = dx < 0
            ? (activeIndex + 1) % thumbs.length
            : (activeIndex - 1 + thumbs.length) % thumbs.length;
          thumbs[next].click();
        }, { passive: true });
      }
    }

    /* ---------- Variant data ---------- */
    var variantScript = section.querySelector('[data-psp-product-json]');
    var variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    var mediaScript = section.querySelector('[data-psp-media-json]');
    var mediaList = mediaScript ? JSON.parse(mediaScript.textContent) : [];

    var optionGroups = section.querySelectorAll('[data-psp-option-index]');
    var selectedOptions = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.psp-pill.is-active');
      selectedOptions.push(active ? active.dataset.pspOptionValue : null);
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selectedOptions.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateForVariant(variant) {
      if (!variant) return;
      var priceCurrent = section.querySelector('[data-psp-price-current]');
      var priceCompare = section.querySelector('[data-psp-price-compare]');
      var installment = section.querySelector('[data-psp-installment]');
      var priceOnetime = section.querySelector('[data-psp-price-onetime]');
      var skuEl = section.querySelector('[data-psp-sku]');
      var invEl = section.querySelector('[data-psp-inventory]');
      var idInput = section.querySelector('[data-psp-variant-id]');
      var atc = section.querySelector('[data-psp-atc]');
      var atcLabel = section.querySelector('[data-psp-atc-label]');

      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (priceOnetime) priceOnetime.textContent = formatMoney(variant.price);
      if (installment) installment.textContent = formatMoney(Math.round(variant.price * 0.25));
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (skuEl) skuEl.textContent = 'SKU: ' + (variant.sku || '—');
      if (idInput) idInput.value = variant.id;

      var available = variant.available !== false;
      if (atc) atc.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? 'Add to Cart' : 'Sold Out';
      if (invEl) {
        invEl.textContent = (available && variant.inventory_management && variant.inventory_quantity <= 10)
          ? 'Only ' + variant.inventory_quantity + ' left'
          : '';
      }

      if (variant.featured_media && variant.featured_media.id) {
        var media = mediaList.find(function (m) { return m.id === variant.featured_media.id; });
        var mainImg = section.querySelector('[data-psp-main-image]');
        if (media && mainImg) {
          mainImg.src = media.preview_image ? media.preview_image.src : mainImg.src;
        }
      }

      updateStickyBar(variant);
    }

    optionGroups.forEach(function (group, groupIndex) {
      group.querySelectorAll('.psp-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          group.querySelectorAll('.psp-pill').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          selectedOptions[groupIndex] = pill.dataset.pspOptionValue;
          var variant = findVariant();
          if (variant) updateForVariant(variant);
        });
      });
    });

    /* ---------- Purchase type: one-time vs subscribe ---------- */
    var purchaseRadios = section.querySelectorAll('[data-psp-purchase-radio]');
    var sellingPlanInput = section.querySelector('[data-psp-selling-plan-input]');
    purchaseRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        section.querySelectorAll('.psp-radio-card').forEach(function (card) { card.classList.remove('is-active'); });
        radio.closest('.psp-radio-card').classList.add('is-active');
        if (sellingPlanInput) {
          sellingPlanInput.value = radio.value === 'subscribe' ? (section.dataset.firstSellingPlan || '') : '';
        }
      });
    });

    /* ---------- Quantity stepper ---------- */
    var qtyInput = section.querySelector('[data-psp-qty-input]');
    var qtyMinus = section.querySelector('[data-psp-qty-minus]');
    var qtyPlus = section.querySelector('[data-psp-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    }

    /* ---------- Sticky Add to Cart bar ---------- */
    var stickyBar = document.querySelector('[data-psp-sticky]');
    function updateStickyBar(variant) {
      if (!stickyBar) return;
      var priceEl = stickyBar.querySelector('[data-psp-sticky-price]');
      var variantEl = stickyBar.querySelector('[data-psp-sticky-variant]');
      if (priceEl && variant) priceEl.textContent = formatMoney(variant.price);
      if (variantEl && variant) variantEl.textContent = variant.title === 'Default Title' ? '' : variant.title;
    }
    var stickyAtc = stickyBar ? stickyBar.querySelector('[data-psp-sticky-atc]') : null;
    var mainForm = section.querySelector('form[id^="product-form-"]');
    if (stickyAtc && mainForm) {
      stickyAtc.addEventListener('click', function () {
        var submitBtn = mainForm.querySelector('[data-psp-atc]');
        if (submitBtn && !submitBtn.disabled) {
          mainForm.requestSubmit ? mainForm.requestSubmit(submitBtn) : submitBtn.click();
        }
      });
    }

    var atcButton = section.querySelector('[data-psp-atc]');
    if (stickyBar && atcButton) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 200);
        });
      }, { threshold: 0 });
      observer.observe(atcButton);
    }
  }

  function boot() {
    document.querySelectorAll('.psp[id^="psp-"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.psp[id^="psp-"]');
    if (section) init(section);
  });
})();
